import React from "react";
import styles from "./timestamp.module.css";
import { useLocale } from "~hooks/i18n/useLocale";
import { Locale } from "~constants/i18n";
import timeFormat, { getTimezoneAbbreviation } from "~utils/timeFormat";

export type TimestampProps = {
  lastUpdate: string;
};

export default function Timestamp(props: TimestampProps) {
  const { lastUpdate } = props;
  const { isJapanese } = useLocale();

  // timezone abbreviation is based off of URL path and not users locale
  const formattedDateTime = React.useMemo(() => {
    if (!lastUpdate) return null;

    const date = new Date(lastUpdate);

    if (isNaN(date.getTime())) return null;

    const currentLocale = (isJapanese ? Locale.Ja : Locale.En) as Locale;
    const timeZoneAbbrev = getTimezoneAbbreviation(date, currentLocale);

    if (isJapanese) {
      const dateTime = timeFormat(date, Locale.Ja, "yyyy-MM-dd HH:mm");

      return `${dateTime} ${timeZoneAbbrev}`;
    }

    const time = timeFormat(date, Locale.En, "h:mm a");
    const dateStr = timeFormat(date, Locale.En, "MM/dd/yy");

    return `${time} ${timeZoneAbbrev} ${dateStr}`;
  }, [lastUpdate, isJapanese]);

  if (!formattedDateTime) return null;

  return (
    <time
      dateTime={new Date(lastUpdate).toISOString()}
      className={styles.timeStamp}
      suppressHydrationWarning
    >
      {formattedDateTime}
    </time>
  );
}
